import { usePublicOrderWithItems } from "@babackapp/private-api-client/client/use-search-public-order";
import type { Order } from "../types";

export function usePublicOrder(orderId: string) {
  return usePublicOrderWithItems<Order>(orderId, {
    select: (data) => data as Order,
  });
}
